import type { LandingHeroCopy } from '@repo/api-contracts';
import { type MutationError, trpc } from '@/shared/api';

interface UseSetLandingHeroImageCopyOptions {
  readonly onSuccess?: () => void;
}

/** 배너 문구를 통째로 저장한다. 모든 필드가 null 이면 문구를 지운다(연결 상품 정보만 남는다). */
export const useSetLandingHeroImageCopy = ({
  onSuccess,
}: UseSetLandingHeroImageCopyOptions = {}) => {
  const mutation = trpc.landing.setHeroImageCopy.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    setCopy: (id: string, copy: LandingHeroCopy) => mutation.mutate({ id, ...copy }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
